export default {
    isFeatureEnabled: state => state.isFeatureEnabled    
}